import React from "react";
import { Autocomplete, Box, FormControl, InputLabel, MenuItem, Select, TextField, Typography } from "@mui/material";

export default function CatalogVisibilityFields({ visibility, setVisibility, selected, setSelected, organizations, loading, error, greek }) {
  return (
    <Box sx={{ mt: 2, mb: 1, p: 2, border: 1, borderColor: "divider", borderRadius: 2 }}>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {greek ? "Διαθεσιμότητα στον κατάλογο" : "Catalogue visibility"}
      </Typography>
      <FormControl fullWidth size="small">
        <InputLabel>{greek ? "Ορατό σε" : "Visible to"}</InputLabel>
        <Select value={visibility} label={greek ? "Ορατό σε" : "Visible to"}
          onChange={(event) => { setVisibility(event.target.value); setSelected([]); }}>
          {visibility === "organization" && <MenuItem value="organization">{greek ? "Μόνο στον οργανισμό μου (υφιστάμενο)" : "My organization only (existing)"}</MenuItem>}
          <MenuItem value="global">{greek ? "Όλους τους οργανισμούς" : "All organizations"}</MenuItem>
          <MenuItem value="selected">{greek ? "Επιλεγμένους οργανισμούς" : "Selected organizations"}</MenuItem>
        </Select>
      </FormControl>
      {visibility === "selected" && (
        <Autocomplete multiple options={organizations} value={selected}
          onChange={(_event, values) => setSelected(values)}
          loading={loading} disabled={loading}
          renderInput={(params) => <TextField {...params} size="small" sx={{ mt: 1.5 }}
            label={greek ? "Οργανισμοί" : "Organizations"}
            helperText={error || (greek ? "Επιλέξτε τουλάχιστον έναν οργανισμό." : "Select at least one organization.")}
            error={Boolean(error)} />}
        />
      )}
    </Box>
  );
}

